import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddCitiesComponent } from 'src/app/components/setup/geo/cities/add/add.component';
import { EditCitiesComponent } from 'src/app/components/setup/geo/cities/edit/edit.component';
import { ListCitiesComponent } from 'src/app/components/setup/geo/cities/list/list.component';
import { ListPincodeComponent } from 'src/app/components/setup/geo/pincodes/pincodes.component';
import { AddStatesComponent } from 'src/app/components/setup/geo/states/add/add.component';
import { EditStatesComponent } from 'src/app/components/setup/geo/states/edit/edit.component';
import { ListStatesComponent } from 'src/app/components/setup/geo/states/list/list.component';

const routes: Routes = [
  {path:'states',component: ListStatesComponent},
  {path:'states/add',component: AddStatesComponent},
  {path:'states/edit/:id',component: EditStatesComponent},

  {path:'cities',component: ListCitiesComponent},
  {path:'cities/add',component: AddCitiesComponent},
  {path:'cities/edit/:id',component: EditCitiesComponent},

  {path:'pincodes',component: ListPincodeComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeoRoutingModule { }
